import { render, staticRenderFns } from "./Observaciones.vue?vue&type=template&id=58ad07b9&scoped=true"
import script from "./Observaciones.vue?vue&type=script&lang=js"
export * from "./Observaciones.vue?vue&type=script&lang=js"
import style0 from "./Observaciones.vue?vue&type=style&index=0&id=58ad07b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ad07b9",
  null
  
)

export default component.exports